/* Excel Filters — faceted collection filter.
   Builds Pack size / Brand / Filter area / Availability facets from each card's data-*
   attributes, filters the grid client-side (AND across groups, OR within a group), shows
   live counts + removable active chips, and runs as an off-canvas drawer on mobile.

   Also handles ?q=<part number> (2026-09-01). 39 of our 101 ranking URLs are collection
   pages answering a part-number query — 11 of them the 70-product all-pool hub — and the
   visitor previously landed on the full grid with no way to narrow by the number they
   searched (docs/COLLECTION_CANNIBALISATION_2026-09-01.md). ?q= resolves the term through
   assets/ef-xref-index.json (the same index and the same match cascade the search page
   uses) and filters the grid to it. The index is fetched ONLY when ?q= is present. */
(function () {
  'use strict';

  var ROOT = '[data-ef-collf]';
  var PANEL = '[data-ef-collection-filters]';
  var BODY = '[data-ef-filter-body]';
  var GRID = '.ef-coll-grid';
  var CARD = '.ef-coll-card';

  var CHEVRON = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m6 9 6 6 6-6"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M4 12.5 9.5 18 20 6.5"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M6 6l12 12M18 6 6 18"/></svg>';

  var SQFT_BANDS = [
    { key: 'u50', label: 'Under 50 sq ft', test: function (n) { return n < 50; } },
    { key: '50-100', label: '50–100 sq ft', test: function (n) { return n >= 50 && n < 100; } },
    { key: '100-200', label: '100–200 sq ft', test: function (n) { return n >= 100 && n < 200; } },
    { key: '200-400', label: '200–400 sq ft', test: function (n) { return n >= 200 && n < 400; } },
    { key: 'o400', label: '400+ sq ft', test: function (n) { return n >= 400; } }
  ];
  var PACK_ORDER = ['1', '2', '3', '4', '5', '6', '8', '10', '12', '15'];

  function el(tag, attrs, kids) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else if (attrs[k] !== null && attrs[k] !== undefined) node.setAttribute(k, attrs[k]);
      });
    }
    (kids || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function num(v) { var m = String(v || '').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; }
  function sqftBand(card) {
    var n = num(card.getAttribute('data-sqft'));
    if (n === null) return null;
    for (var i = 0; i < SQFT_BANDS.length; i++) if (SQFT_BANDS[i].test(n)) return SQFT_BANDS[i].key;
    return null;
  }

  /* ---- ?q= part-number resolution ----
     Normalization and the match cascade mirror assets/ef-search-xref.js, which mirrors
     scripts/build-xref-index.mjs. Keep the three in step: if search resolves a term, the
     hub must resolve it the same way, or the same query gives two different answers. */
  var strictKey = function (s) { return String(s).toUpperCase().replace(/[ \-®™]/g, ''); };
  var looseKey = function (s) { return String(s).toUpperCase().replace(/[^A-Z0-9]/g, ''); };
  var aliasKey = function (s) { return String(s).toUpperCase().replace(/&/g, 'AND').replace(/[^A-Z0-9]/g, ''); };
  var hasDigit = function (s) { return /[0-9]/.test(s); };

  function resolveIdxs(index, query) {
    var q = strictKey(query);
    if (index.keys[q]) return index.keys[q];

    var lq = looseKey(query);
    if (index.loose && index.loose[lq]) return index.loose[lq];
    if (index.keys[lq]) return index.keys[lq];

    // Colloquial family names ('ccp', 'swimclear'). After the part-number strategies:
    // a real part number is always more specific than a family alias. Group .t entries are
    // stored already alias-keyed by build-xref-index.mjs, so this is a direct compare —
    // same as aliasGroupFor() in ef-search-xref.js, including the 3-char floor.
    var ak = aliasKey(query);
    if (ak.length >= 3) {
      var groups = index.aliasGroups || [];
      for (var g = 0; g < groups.length; g++) {
        if ((groups[g].t || []).indexOf(ak) !== -1) return groups[g].p || [];
      }
    }

    // A filter housing named with its model ("C5020", "Clean & Clear Plus 520"): the matcher
    // and the order site search uses (assets/ef-fit-match.js).
    var fm = window.EfFitMatch;
    if (fm && fm.listedFor && index.housings) {
      var listed = fm.listedFor(query, index.housings.map(function (h) { return fm.entry(h.n, { brand: h.b, housing: true, ref: h }); }));
      if (listed.length) return listed.map(function (o) { return o.product; });
    }

    // Multi-word: union over digit-bearing tokens only, so 'hayward c7030' resolves the
    // part while 'hayward' alone never claims a key.
    if (/\s/.test(query)) {
      var seen = {}, out = [];
      query.split(/\s+/).forEach(function (word) {
        var k = strictKey(word);
        if (!hasDigit(k)) return;
        (index.keys[k] || []).concat(index.loose ? (index.loose[looseKey(word)] || []) : [])
          .forEach(function (i) { if (!seen[i]) { seen[i] = 1; out.push(i); } });
      });
      if (out.length) return out;
    }

    // No prefix fallback: a partial number is not a match (owner, 2026-10-14).
    return [];
  }

  var handleOf = function (url) { var m = String(url || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; };

  function init() {
    var root = document.querySelector(ROOT);
    var panel = document.querySelector(PANEL);
    var body = panel && panel.querySelector(BODY);
    var grid = document.querySelector(GRID);
    if (!root || !panel || !body || !grid) return;

    /* EFCollectionRest holds the 25 in-document cards plus the ones it fetched from
       ?view=cards, so the facets, counts and sort still cover the whole collection. */
    var cards = window.EFCollectionRest
      ? window.EFCollectionRest.cards.slice()
      : Array.prototype.slice.call(grid.querySelectorAll(CARD));
    if (!cards.length) { panel.setAttribute('hidden', ''); return; } /* empty collection: hide the shell instead of leaving "Loading filters…" forever */
    window.EFCollectionCards = cards;
    var order = new Map();
    cards.forEach(function (c, i) { order.set(c, i); });

    /* ---- accessors ---- */
    var packOf = function (c) { return (c.getAttribute('data-pack') || '').trim(); };
    // Brand facet prefers partnumber/fits signals (data-fits), then brand-collection membership
    // (data-brands). Unioning both lets hub ?brand=jacuzzi work even when the branded
    // collection membership is still incomplete.
    var brandsOf = function (c) {
      var fits = (c.getAttribute('data-fits') || '').trim();
      var brands = (c.getAttribute('data-brands') || '').trim();
      var set = {};
      (fits + ' ' + brands).trim().split(/\s+/).forEach(function (x) { if (x) set[x] = true; });
      return Object.keys(set);
    };
    var titleCase = function (s) { return String(s).split('-').map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join('-'); };
    /* Facet labels use the brand names of the Popular Brands menu
       (data/brand-collections/collections.json) and, for brands off the menu, the Find My
       Filter list. The keys are the brand keys snippets/ef-collection-card.liquid writes into
       data-fits / data-brands; keep the two lists in sync. */
    var BRAND_LABELS = {
      hayward: 'Hayward', pentair: 'Pentair', jandy: 'Jandy', jacuzzi: 'Jacuzzi', waterway: 'Waterway',
      waterco: 'Waterco', rainbow: 'Rainbow', 'sta-rite': 'Sta-Rite', sundance: 'Sundance',
      coleman: 'Coleman / Maax', purex: 'Purex', cmp: 'CMP', 'leisure-bay': 'Leisure Bay',
      'aqua-leisure': 'Aqua Leisure', sunrise: 'Sunrise Spas', advantage: 'Advantage Electric',
      artesian: 'Artesian Spas', coleco: 'Coleco', hotspring: 'Hot Spring', martec: 'Martec',
      saratoga: 'Saratoga Spas'
    };
    var brandLabel = function (k) { return BRAND_LABELS[k] || titleCase(k); };
    var inStock = function (c) { return c.getAttribute('data-instock') === '1'; };
    var isSpa = function (c) { return c.getAttribute('data-spa') === '1'; };
    var hasValue = function (c, key, val) {
      if (key === 'pack') return packOf(c) === val;
      if (key === 'brand') return brandsOf(c).indexOf(val) !== -1;
      if (key === 'sqft') return sqftBand(c) === val;
      if (key === 'stock') return inStock(c);
      if (key === 'spa') return (val === '1') === isSpa(c);
      return false;
    };

    /* ---- build the facet model from the cards present ---- */
    var groups = [];

    var packVals = {};
    cards.forEach(function (c) { var p = packOf(c); if (p) packVals[p] = true; });
    var packOpts = PACK_ORDER.filter(function (p) { return packVals[p]; }).map(function (p) { return { value: p, label: p + '-Pack' }; });
    if (packOpts.length > 1) groups.push({ key: 'pack', label: 'Pack size', kind: 'pills', options: packOpts });

    var brandSet = {};
    cards.forEach(function (c) { brandsOf(c).forEach(function (b) { if (b) brandSet[b] = true; }); });
    var brandOpts = Object.keys(brandSet).map(function (k) { return { value: k, label: brandLabel(k) }; })
      .sort(function (a, b) { return a.label.localeCompare(b.label); });
    if (brandOpts.length && !panel.hasAttribute('data-ef-hide-brand')) groups.push({ key: 'brand', label: 'Brand', kind: 'list', options: brandOpts });

    var bandsPresent = {};
    cards.forEach(function (c) { var b = sqftBand(c); if (b) bandsPresent[b] = true; });
    var sqftOpts = SQFT_BANDS.filter(function (b) { return bandsPresent[b.key]; }).map(function (b) { return { value: b.key, label: b.label }; });
    if (sqftOpts.length > 1) groups.push({ key: 'sqft', label: 'Filter area', kind: 'list', options: sqftOpts });

    var hasSpaCards = cards.some(isSpa);
    var hasPoolCards = cards.some(function (c) { return !isSpa(c); });
    if (hasSpaCards && hasPoolCards) {
      groups.push({ key: 'spa', label: 'Type', kind: 'list', options: [
        { value: '0', label: 'Pool cartridges' },
        { value: '1', label: 'Spa cartridges' }
      ] });
    }

    var hasOut = cards.some(function (c) { return !inStock(c); });
    if (hasOut) groups.push({ key: 'stock', label: 'Availability', kind: 'list', options: [{ value: 'instock', label: 'In stock only' }] });

    if (!groups.length) { panel.setAttribute('hidden', ''); return; }

    /* ---- render facet UI ---- */
    body.innerHTML = '';
    groups.forEach(function (g) {
      var det = el('details', { class: 'ef-collf-group', open: '' });
      var sum = el('summary', { class: 'ef-collf-group__summary' }, [
        el('span', { class: 'ef-collf-group__label', text: g.label }),
        el('span', { class: 'ef-collf-group__chev', html: CHEVRON })
      ]);
      det.appendChild(sum);
      var opts = el('div', { class: 'ef-collf-group__opts' + (g.kind === 'pills' ? ' is-pills' : '') });
      g.options.forEach(function (o) {
        var input = el('input', { type: 'checkbox', name: g.key, value: o.value });
        input.className = 'ef-collf-input';
        var label;
        if (g.kind === 'pills') {
          label = el('label', { class: 'ef-collf-pill' }, [input, el('span', { text: o.label })]);
        } else {
          label = el('label', { class: 'ef-collf-opt' }, [
            input,
            el('span', { class: 'ef-collf-opt__box', html: CHECK }),
            el('span', { class: 'ef-collf-opt__label', text: o.label }),
            el('span', { class: 'ef-collf-opt__count' })
          ]);
        }
        label.setAttribute('data-ef-opt', g.key + '::' + o.value);
        opts.appendChild(label);
      });
      det.appendChild(opts);
      body.appendChild(det);
    });

    /* ---- references ---- */
    var inputs = Array.prototype.slice.call(body.querySelectorAll('.ef-collf-input'));
    var countEls = qa('[data-ef-filter-count]');
    var applyCountEls = qa('[data-ef-apply-count]');
    var activeWrap = document.querySelector('[data-ef-active-pills]');
    var activeBadge = document.querySelector('[data-ef-active-count]');
    var emptyEl = document.querySelector('[data-ef-filter-empty]');
    var sortSel = document.querySelector('[data-ef-sort]');
    var total = cards.length;

    function qa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

    /* ?q= state. qCards is null until the index resolves the term to at least one card in
       THIS collection; until then, and forever if it resolves to nothing, the grid behaves
       exactly as it does today. A URL param must never be able to leave a visitor staring
       at an empty grid. */
    var qTerm = '';
    var qCards = null;
    var qExact = false; // the term is a part number in the index, not a family alias or a prefix

    function readState() {
      var s = { pack: [], brand: [], sqft: [], spa: [], stock: false };
      inputs.forEach(function (i) {
        if (!i.checked) return;
        if (i.name === 'stock') s.stock = true;
        else if (s[i.name]) s[i.name].push(i.value);
      });
      return s;
    }

    function matchesExcept(c, s, except) {
      /* Not exceptable: ?q= is not a facet group, so it constrains every facet count too.
         Filter to one product and the Brand counts should read 1, not 70. */
      if (qCards && !qCards.has(c)) return false;
      if (except !== 'pack' && s.pack.length && s.pack.indexOf(packOf(c)) === -1) return false;
      if (except !== 'brand' && s.brand.length) {
        var bs = brandsOf(c), bok = false;
        for (var bi = 0; bi < bs.length; bi++) if (s.brand.indexOf(bs[bi]) !== -1) { bok = true; break; }
        if (!bok) return false;
      }
      if (except !== 'sqft' && s.sqft.length) { var b = sqftBand(c); if (!b || s.sqft.indexOf(b) === -1) return false; }
      if (except !== 'spa' && s.spa.length === 1 && ((s.spa[0] === '1') !== isSpa(c))) return false;
      if (except !== 'stock' && s.stock && !inStock(c)) return false;
      return true;
    }
    function matches(c, s) { return matchesExcept(c, s, null); }

    function labelFor(key, val) {
      if (key === 'q') return 'Part number: ' + val;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].key !== key) continue;
        for (var j = 0; j < groups[i].options.length; j++) if (groups[i].options[j].value === val) return groups[i].options[j].label;
      }
      return val;
    }

    function renderActive(s) {
      if (!activeWrap) return;
      activeWrap.innerHTML = '';
      var items = [];
      /* The part-number chip leads: it is the most specific thing on screen and the reason
         the visitor is looking at a filtered grid at all. */
      if (qCards) items.push({ key: 'q', value: qTerm });
      ['pack', 'brand', 'sqft', 'spa'].forEach(function (k) { s[k].forEach(function (v) { items.push({ key: k, value: v }); }); });
      if (s.stock) items.push({ key: 'stock', value: 'instock' });
      items.forEach(function (it) {
        var chip = el('button', { type: 'button', class: 'ef-collf-chip', 'data-ef-remove': it.key + '::' + it.value }, [
          el('span', { text: labelFor(it.key, it.value) }),
          el('span', { class: 'ef-collf-chip__x', html: CLOSE })
        ]);
        activeWrap.appendChild(chip);
      });
      if (items.length) {
        activeWrap.appendChild(el('button', { type: 'button', class: 'ef-collf-chip ef-collf-chip--clear', 'data-ef-filter-clear': '', text: 'Clear all' }));
      }
      activeWrap.hidden = items.length === 0;
      if (activeBadge) {
        activeBadge.textContent = items.length ? String(items.length) : '';
        activeBadge.hidden = items.length === 0;
      }
    }

    function updateCounts(s) {
      groups.forEach(function (g) {
        g.options.forEach(function (o) {
          var n = 0;
          for (var i = 0; i < cards.length; i++) if (matchesExcept(cards[i], s, g.key) && hasValue(cards[i], g.key, o.value)) n++;
          var lbl = body.querySelector('[data-ef-opt="' + g.key + '::' + o.value + '"]');
          if (!lbl) return;
          var cEl = lbl.querySelector('.ef-collf-opt__count');
          if (cEl) cEl.textContent = n ? String(n) : '';
          var input = lbl.querySelector('input');
          var disable = n === 0 && !(input && input.checked);
          lbl.classList.toggle('is-disabled', disable);
          if (input) input.disabled = disable;
        });
      });
    }

    function applySort() {
      var v = sortSel ? sortSel.value : 'featured';
      var arr = cards.slice();
      if (v === 'price-asc') arr.sort(function (a, b) { return (num(a.getAttribute('data-price')) || 0) - (num(b.getAttribute('data-price')) || 0); });
      else if (v === 'price-desc') arr.sort(function (a, b) { return (num(b.getAttribute('data-price')) || 0) - (num(a.getAttribute('data-price')) || 0); });
      else arr.sort(function (a, b) { return order.get(a) - order.get(b); });
      cards = arr;
      window.EFCollectionCards = cards;
      document.dispatchEvent(new CustomEvent('ef:collf:applied'));
    }

    function apply() {
      var s = readState();
      var visible = 0;
      cards.forEach(function (c) { var show = matches(c, s); c.hidden = !show; if (show) visible++; });
      countEls.forEach(function (e) { e.textContent = String(visible); });
      applyCountEls.forEach(function (e) { e.textContent = visible === total ? 'all' : String(visible); });
      if (emptyEl) emptyEl.hidden = visible > 0;
      /* 1-2 results would otherwise sit in a 3-column skeleton — see .is-sparse in
         ef-collection-card.css. Driven off the same count the toolbar already shows. */
      grid.classList.toggle('is-sparse', visible > 0 && visible <= 2);
      renderQNote(visible);
      updateCounts(s);
      renderActive(s);
      writeUrl(s);
      document.dispatchEvent(new CustomEvent('ef:collf:applied'));
    }

    /* Says out loud what the chip only implies. The visitor arrived from a search engine on a
       page headlined "Pool Filter Cartridges" whose intro invites them to browse all 70 — without
       this line nothing connects the narrowed grid to the number they typed into Google. */
    var qNote = null;
    function renderQNote(visible) {
      if (!qCards) { if (qNote) { qNote.remove(); qNote = null; } return; }
      if (!qNote) {
        qNote = el('p', { class: 'ef-coll-qnote', role: 'status', 'aria-live': 'polite' });
        if (activeWrap && activeWrap.parentNode) activeWrap.parentNode.insertBefore(qNote, activeWrap);
        else grid.parentNode.insertBefore(qNote, grid);
      }
      qNote.textContent = '';
      qNote.appendChild(document.createTextNode(
        visible === 1 ? 'Showing the Excel Filters match for ' : 'Showing ' + visible + ' Excel Filters matches for '));
      qNote.appendChild(el('strong', { text: qTerm }));
      qNote.appendChild(document.createTextNode('.'));
      /* One part number can belong to cartridges of different media area: the workbook lists an
         aftermarket successor number on each cartridge it replaces. Say so, or the cards read as
         duplicates and the shopper picks by price. Only for an exact part number, not a family
         alias or a prefix, and not for one cartridge in two pack sizes. */
      if (qExact && visible > 1) {
        var areas = {};
        cards.forEach(function (c) {
          if (c.hidden || !qCards.has(c)) return;
          var each = num(c.getAttribute('data-sqft')) / (num(c.getAttribute('data-pack')) || 1);
          if (each) areas[Math.round(each * 10)] = true;
        });
        if (Object.keys(areas).length > 1) {
          qNote.appendChild(document.createTextNode(' This number is listed for more than one cartridge. Compare the filtration area and the filter models on each before you choose.'));
        }
      }
    }

    /* ---- URL state ---- */
    function writeUrl(s) {
      var p = new URLSearchParams(window.location.search);
      ['pack', 'brand', 'sqft'].forEach(function (k) { p.delete(k); if (s[k].length) p.set(k, s[k].join(',')); });
      p.delete('spa'); if (s.spa.length === 1) p.set('spa', s.spa[0]);
      p.delete('stock'); if (s.stock) p.set('stock', '1');
      /* Only keep ?q= while it is actually filtering. A term that resolved to nothing here
         is dropped from the URL rather than left to look like an active filter. */
      p.delete('q'); if (qCards && qTerm) p.set('q', qTerm);
      var q = p.toString();
      window.history.replaceState(window.history.state, '', q ? window.location.pathname + '?' + q : window.location.pathname);
    }
    function restoreUrl() {
      var p = new URLSearchParams(window.location.search);
      function set(name) {
        var raw = p.get(name); if (!raw) return;
        var vals = raw.split(',');
        inputs.forEach(function (i) { if (i.name === name && vals.indexOf(i.value) !== -1) i.checked = true; });
      }
      ['pack', 'brand', 'sqft', 'spa'].forEach(set);
      if (p.get('stock') === '1') inputs.forEach(function (i) { if (i.name === 'stock') i.checked = true; });
      return (p.get('q') || '').trim();
    }

    /* Fetch the xref index and, if the term resolves to cards present in this collection,
       switch the q filter on and re-apply. Everything here is best-effort: any failure
       (no index URL, network error, schema bump, no match) leaves the grid unfiltered. */
    function resolveQ(raw) {
      if (!raw || raw.length > 40) return;
      var tag = document.querySelector('script[data-ef-xref-index]');
      var url = tag && tag.getAttribute('data-ef-xref-index');
      if (!url) return;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (index) {
          if (!index || index.v !== 1 || !index.keys) return;
          var idxs = resolveIdxs(index, raw);
          if (!idxs.length) return;
          var wanted = {};
          idxs.forEach(function (i) { var p = index.products[i]; if (p && p.h) wanted[p.h] = true; });
          var hits = cards.filter(function (c) { return wanted[handleOf(c.getAttribute('data-product-url'))]; });
          if (!hits.length) return; // resolved, but to products this collection does not carry
          qTerm = raw;
          qCards = new Set(hits);
          qExact = !!(index.keys[strictKey(raw)] || (index.loose && index.loose[looseKey(raw)]) || index.keys[looseKey(raw)]);
          apply();
        })
        .catch(function () { /* leave the grid unfiltered */ });
    }

    function clearQ() {
      qTerm = ''; qCards = null; qExact = false;
      apply();
    }

    function clearAll() {
      inputs.forEach(function (i) { i.checked = false; });
      clearQ();
    }

    /* ---- mobile drawer ---- */
    var openBtn = document.querySelector('[data-ef-filter-open]');
    function openDrawer() {
      root.classList.add('is-filter-open');
      document.body.classList.add('ef-collf-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      var first = body.querySelector('input, button, summary');
      if (first) first.focus();
    }
    function closeDrawer() {
      root.classList.remove('is-filter-open');
      document.body.classList.remove('ef-collf-lock');
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
    }

    /* ---- wire events ---- */
    body.addEventListener('change', function (e) { if (e.target.matches('.ef-collf-input')) apply(); });

    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-ef-remove]');
      if (remove) {
        var token = remove.getAttribute('data-ef-remove');
        // The q chip has no backing checkbox, so it needs its own branch — without this the
        // generic loop no-ops and the chip becomes unremovable.
        if (token.indexOf('q::') === 0) { clearQ(); return; }
        inputs.forEach(function (i) { if (i.name + '::' + i.value === token) i.checked = false; });
        apply();
        return;
      }
      if (e.target.closest('[data-ef-filter-clear]')) { clearAll(); return; }
      if (e.target.closest('[data-ef-filter-open]')) { openDrawer(); return; }
      if (e.target.closest('[data-ef-filter-close]') || e.target.closest('[data-ef-filter-apply]')) { closeDrawer(); return; }
      if (e.target.matches('[data-ef-collf-overlay]')) { closeDrawer(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-filter-open')) closeDrawer();
    });

    if (sortSel) sortSel.addEventListener('change', applySort);

    /* ---- go ----
       apply() first so the grid is correct and interactive immediately; resolveQ() re-applies
       when (and only if) the index comes back with a match. The unfiltered grid is never
       blocked on a network round-trip. */
    var qRaw = restoreUrl();
    apply();
    if (qRaw) resolveQ(qRaw);
  }

  function boot() {
    if (window.EFCollectionRest) window.EFCollectionRest.ready(init);
    else init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
